<template>
    <f-dialog
        v-model       = "value"
        :show-header  = "true"
        :full-screen  = "false"
        :hide-actions = "false"
        :width        = "600"
        :show-save    = "enableStore"
        :title        = "$t('inb.upload.confirm.title')"
        :store-label  = "$t('inb.upload.confirm.store')"
        @store        = "onForce"
        @cancel       = "onClose"
    >
        <template v-slot:content>
            <div class="mt-2">
                <div class="lm-border pa-3 mt-3">
                    <v-row dense>
                        <v-col>
                            {{ $t("inb.upload.confirm.message") }}
                        </v-col>
                    </v-row>
                </div>
                <div class="lm-border pa-3 mt-3">
                    <v-row dense>
                        <v-col class="col-6">
                            Datei
                        </v-col>
                        <v-col class="col-3">
                            verarbeitet am
                        </v-col>
                        <v-col class="col-3">
                            von
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-divider />
                        </v-col>
                    </v-row>
                    <v-row dense v-for="(message,index) in messages" :key="index">
                        <v-col class="col-6">
                            <v-checkbox
                                v-model="message.selected"
                                :label = "message.filename"
                                class  = "mt-0 pt-0"
                                :ripple = "false"
                                @change = "onChange"
                                hide-details
                            />
                        </v-col>
                        <v-col class="col-3">
                            {{ createdDate (message.createdDate) }}
                        </v-col>
                        <v-col class="col-3">
                            {{ message.createdBy }}
                        </v-col>
                    </v-row>
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog";
import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";
export default {
    name: "DImportConfirm",
    components: {
        FDialog
    },

    props: {
        value: {

        },

        messages: {

        },

        files: {

        }
    },

    data: () => ({
        enableStore: false,
    }),

    computed: {
    },

    methods: {
        onChange () {
            let enabled = false;
            this.messages.forEach(message => {
                if (message.selected) {
                    enabled = true;
                }
            })

            this.enableStore = enabled;
        },

        onForce () {
            const selectedFiles = [];
            this.messages.forEach((message, index) => {
                if (message.selected) {
                    selectedFiles.push(this.files[index]);
                }
            });

            Inb.uploadFiles(this, selectedFiles, true).then((data) => {
                this.$emit('uploaded', { files: selectedFiles, messages: data });
            }).catch((error) => {
                console.log(error);
            });

            this.$emit("input", false);
        },

        onClose () {
            this.$emit("input", false);
        },

        createdDate (value) {
            return Core.format.datetime.display(value);
        }
    }
}
</script>

<style scoped>

</style>